// fb-108: a tiny shared store for the Benchmarks issue count (Catalogue sync issues + Skeleton
// structural issues). BenchmarksPage computes it while mounted and publishes it here; the LeftMenu +
// ModuleBar subscribe so the "Benchmarks" nav item (left + top) badges when any of its tabs has an issue.
import { useState, useEffect } from 'react';

let _count = 0;
const _subs = new Set();

export function setBenchmarkIssueCount(n) {
  const v = Number(n) || 0;
  if (v === _count) return;
  _count = v;
  _subs.forEach((fn) => fn(v));
}

export function useBenchmarkIssueCount() {
  const [n, setN] = useState(_count);
  useEffect(() => { _subs.add(setN); setN(_count); return () => { _subs.delete(setN); }; }, []);
  return n;
}
